import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum,AppAction} from 'qcc'
import api, {AppFormResult} from 'api'

export default class SetManagerPassword extends React.PureComponent<AppFormPageProps> {
    state = {}
    

    save = async (formData:any) =>{
        await api.posmerchant.setManagerPassword({id:formData.id,password:formData.manager_password})
        return {result:true} as AppFormResult
    }

    afterSave = () =>{
        AppAction.closeDialog();
    }
    
	render() {
		let {formData,mode} = this.props;
		return (<AppFormLayout defaultButton>
            <AppFormLayout.Form>
            <AppForm loadingData={false} 
                save = {this.save}
                mode={mode} 
                formData={formData} 
                afterSave={()=>{this.afterSave()}}>
                    <AppForm.Section labelWidth={110}>
                        <AppForm.Item field='merchant_name'  label="商户名称" readonly unSave />
						<AppForm.Item field='manager_password' itemType={AppFormItemEnum.input} placeholder='请输入主管账号（与AD域账号保持一致）' label="主管账号" unSave req/>
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/merchant/SetManager.tsx